// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import SnippetsFilledSvg from "@ant-design/icons-svg/es/asn/SnippetsFilled";
import AntdIcon from '../components/AntdIcon';

var SnippetsFilled = function SnippetsFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: SnippetsFilledSvg
  }));
};

SnippetsFilled.displayName = 'SnippetsFilled';
export default React.forwardRef(SnippetsFilled);